import React, { Component } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import * as R from 'ramda'
import Modal from '../../UniformComponents/Modal'
import Button from '../../UniformComponents/Button'
import ModalFooter from '../../UniformComponents/ModalFooter'
import ModalHeader from '../../UniformComponents/ModalHeader'
import Select from '../form/Select'
import Input from '../form/Input'
import { getQuestionTitle, getOptionTitle } from '../../utils/QuestionHelper'

const ANSWER_OPTION_QTYPES = ['UV', 'TL']
@observer
class AddPinnedFilterModal extends Component {
    filterTypes = [
        { value: 'single', label: 'Single Select' },
        { value: 'multi', label: 'Multi Select' },
    ]

    constructor(props) {
        super(props)
        this.state = {
            respondentType: undefined,
            question: undefined,
            filterLabel: undefined,
            filterType: 'single',
        }
    }

    save = async () => {
        const { dashStore } = this.props
        const { addDashboardFilters, toggleShowAddPinnedFilters } = dashStore
        const {
            respondentType,
            question,
            filterLabel,
            filterType,
            answerOptionQuestionId, // for UL/TL question types
        } = this.state

        addDashboardFilters({
            respondentType,
            question,
            filterLabel,
            filterType,
            ...(answerOptionQuestionId ? { answerOptionQuestionId } : {}),
        })
        toggleShowAddPinnedFilters()
    }

    getQuestionOptions = (filterSurveys) => {
        const { dashStore: { appStore: { langcode } } } = this.props
        const { respondentType } = this.state
        const questionSurvey = filterSurveys.filter((s) => s.survey.metadata.taxonomy.respondentType === respondentType)
        const questions = questionSurvey.length ? questionSurvey[0].survey.pages.reduce((qs, p) => {
            if (!p.questions) return qs
            const newQuestions = [...qs, ...p.questions]
            return newQuestions
        }, []) : []
        const formatted = questions.reduce((acc, q) => {
            const questionLabel = getQuestionTitle({
                content: q.content.shortTitle,
                locale: langcode,
                defaultLocale: langcode,
                initialLocale: q.metadata.initialLocale,
            }).text

            if (ANSWER_OPTION_QTYPES.includes(q.questionTypeCode)) {
                const options = R.pathOr([], ['optionSet', 'options'], q)
                options.forEach((opt) => {
                    const optionTitle = getOptionTitle({
                        langs: opt.langs,
                        locale: langcode,
                        defaultLocale: langcode,
                        initialLocale: q.metadata.initialLocale,
                    })
                    const optionText = optionTitle.text ?? ''
                    acc.push({
                        ...q,
                        value: opt.id,
                        label: `${questionLabel} - ${optionText}`,
                    })
                })
            } else {
                acc.push({
                    ...q,
                    value: q.questionId,
                    label: questionLabel,
                })
            }
            return acc
        }, [])
        return formatted
    }

    getRespondentTypes = (filterSurveys, productMap) => {
        const surveysInfo = filterSurveys.map((s) => ({
            respondentType: s.survey.metadata.taxonomy.respondentType,
            surveyType: s.survey.metadata.taxonomy.surveyType,
            industry: s.survey.metadata.productInfo.industrySpecificInfo.industry,
            productType: s.survey.metadata.productInfo.industrySpecificInfo.productType,
        }))

        return surveysInfo.map((si) => R.pathOr(undefined, [
            si.industry,
            'children',
            si.productType,
            'children',
            si.surveyType,
            'children',
            si.respondentType,
        ], productMap)).filter((rt) => !!rt)
    }

    renderControls = () => {
        const { dashStore } = this.props
        const { filterSurveys, productMap } = dashStore
        const respondentTypeOptions = this.getRespondentTypes(filterSurveys, productMap)
        const questionOptions = this.getQuestionOptions(filterSurveys)
        const filterTypeOptions = this.filterTypes

        const {
            respondentType,
            question,
            filterLabel,
            filterType,
        } = this.state

        return (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                <Select
                    label={i18n.t('respondent_type')}
                    name="filterRespondentType"
                    options={respondentTypeOptions}
                    value={respondentTypeOptions.find((rt) => respondentType === rt.value)}
                    onBlur={({ value }) => this.setState({ respondentType: value })}
                    blurOnClear
                />
                <Select
                    label="Question"
                    name="question"
                    options={questionOptions}
                    value={questionOptions.find((q) => (q.value === question))}
                    onBlur={({ value }) => {
                        const selected = questionOptions.find((q) => q.value === value)
                        const isOptionLevel = selected && ANSWER_OPTION_QTYPES.includes(selected.questionTypeCode)
                        this.setState({
                            question: value,
                            answerOptionQuestionId: isOptionLevel ? selected.questionId : undefined,
                        })
                    }}
                    blurOnClear
                />
                <Input
                    label={i18n.t('dashboard.pinnedFilter.label')}
                    name="pinnedFilterLabel"
                    placeholder="Filter label..."
                    onBlur={({ value }) => this.setState({ filterLabel: value })}
                    defaultValue={filterLabel}
                />
                <Select
                    label={i18n.t('dashboard.pinnedFilter.filterType')}
                    name="filterType"
                    options={filterTypeOptions}
                    value={filterTypeOptions.find((f) => f.value === filterType)}
                    onBlur={({ value }) => this.setState({ filterType: value })}
                    blurOnClear
                />
            </div>

        )
    }

    render() {
        const { dashStore } = this.props
        const { showAddPinnedFilter, toggleShowAddPinnedFilters } = dashStore
        const {
            respondentType,
            question,
            filterLabel,
        } = this.state
        const canSave = respondentType && question && filterLabel

        return (
            <Modal
                show={showAddPinnedFilter}
                onClose={toggleShowAddPinnedFilters}
                cssClass="createTemplateModal"
            >
                <ModalHeader>
                    <div className="title">
                        <h3>{i18n.t('report.filter.add')}</h3>
                        <h4>{i18n.t('dashboard.pinnedFilter.subTitle')}</h4>
                    </div>
                </ModalHeader>
                <div className="body">
                    <div style={{ marginBottom: '10px' }}>
                        {this.renderControls()}
                    </div>
                </div>
                <ModalFooter>
                    <div style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}>
                        <Button
                            label={(
                                <div>
                                    {i18n.t('cancel')}
                                </div>
                            )}
                            cssClass="tertiary regular"
                            onClick={toggleShowAddPinnedFilters}
                        />
                        <Button
                            label={(
                                <div>
                                    {i18n.t('save')}
                                </div>
                            )}
                            cssClass="primary regular"
                            style={{ width: '200px', fontWeight: 600, textAlign: 'center' }}
                            onClick={this.save}
                            disabled={!canSave}
                        />
                    </div>
                </ModalFooter>
            </Modal>
        )
    }
}

export default AddPinnedFilterModal
